import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { Nav, NavDropdown } from "react-bootstrap";
import { connect } from "react-redux";
import Navbar from "react-bootstrap/Navbar";

import { RegisterService, onLogout } from "./../../actions/index";
import "./header.css";

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      scrolled: false,
    };
    this.user = localStorage.getItem("token");
    this.user_type = localStorage.getItem("user_type");
  }

  listenScrollEvent = (e) => {
    if (window.scrollY > 24) {
      this.setState({ scrolled: true });
    } else {
      this.setState({ scrolled: false });
    }
  };
  MobileScrollEvent = (e) => {
    if (window.innerWidth < 768) {
      this.setState({ scrolled: false });
    }
  };
  componentDidMount() {
    window.addEventListener("scroll", this.listenScrollEvent);
  }
  navfitnessUser = () => {
    this.props.typeOfService("FITNESS");
    this.props.history.push("/service/fitnesstrainer");
    if (this.user) {
      this.props.history.push("/booksession");
    }
  };
  navYogaUser = () => {
    this.props.typeOfService("YOGA");
    this.props.history.push("/service/yogatrainer");
    if (this.user) {
      this.props.history.push("/booksession");
    }
  };
  navDietUser = () => {
    this.props.typeOfService("DIET");
    this.props.history.push("/diet");
  };

  async signout() {
    localStorage.clear();
    this.props.history.replace("/");
    window.location.reload();
  }

  render() {
    return (
      <Navbar
        expand="lg custom"
        className={this.state.scrolled ? "custom-navbar-color" : null}
      >
        <Navbar.Brand className="home col-xs-6">
          {/* col-sm-6 col-md-3 col-lg-3  */}
          <a href="/">
            <img
              className="bowootheadericon"
              src={require("../../assests/fitlogo.png")}
            />
          </a>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="mr-auto"></Nav>

          <Nav>
            <NavDropdown title="Services" id="basic-nav-dropdown" className="">
              <NavDropdown.Item onClick={() => this.navfitnessUser()}>
                Personal Trainer at home
              </NavDropdown.Item>
              <NavDropdown.Item onClick={() => this.navYogaUser()}>
                Yoga Trainer at home
              </NavDropdown.Item>
              <NavDropdown.Item onClick={() => this.navDietUser()}>
                Diet Plans
              </NavDropdown.Item>
              {/* <NavDropdown.Item
                onClick={() => this.props.history.push("/fitnessplan")}
              >
                Fitness Plans
              </NavDropdown.Item> */}
              <NavDropdown.Item
                onClick={() => this.props.history.push("/institute")}
              >
                Fitness/Nutritionist Certifications
              </NavDropdown.Item>
              {/* <NavDropdown.Item onClick={() => this.props.history.push("/shopnow")}>
                Shop Now (Coming soon)
              </NavDropdown.Item>
              <NavDropdown.Item  onClick={() => this.props.history.push("/foodzone")}>
                Food Zone (Coming soon)
              </NavDropdown.Item>  */}
            </NavDropdown>
            {/* {this.props.typeofuser==="User"&& "Trainer"?null:( */}
            {this.user ? null : (
              <Nav.Link
                href="https://play.google.com/store/apps/details?id=com.fitfinity.trainers&pcampaignid=web_share"
                target="_blank"
                className=""
              >
                Become a Trainer
                <br />
              </Nav.Link>
            )}
            {this.user && this.user_type == "U" ? (
              <Nav.Link
                onClick={() => this.props.history.push("/user/userDashboard")}
                className=""
              >
                Dashboard
              </Nav.Link>
            ) : null}
            {this.user && this.user_type == "A" ? (
              <Nav.Link
                onClick={() => this.props.history.push("/admin/adminDashboard")}
                className=""
              >
                Dashboard
              </Nav.Link>
            ) : null}

            {this.user ? (
              <Nav.Link
                className="button-slanted"
                onClick={() => {
                  this.signout();
                }}
              >
                <span className="button-slanted-content">LOGOUT</span>
              </Nav.Link>
            ) : (
              <Nav.Link
                onClick={() => this.props.history.push("/login")}
                className="button-slanted"
              >
                <span className="button-slanted-content">LOGIN</span>
              </Nav.Link>
            )}
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    );
  }
}

const mapStateToProps = (State) => {
  return {
    User: State.sessionState ? State.sessionState.authUser : null,
    typeofuser: State.userDetail.TypeofUser
      ? State.userDetail.TypeofUser
      : null,
    user: State.userDetail,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    typeOfService: (services) => {
      dispatch(RegisterService(services));
    },
    logout: (data) => {
      dispatch(onLogout());
    },
  };
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Header));
